export default __webpack_public_path__ + "static/media/BIGstub.d38a8f20.jpg";